import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { Component } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';
import { UptimeRepoService } from '@client/app/services/api/uptime-repo/uptime-repo.service';
import { MonUIRouterTransitionService } from '@monsido/services/ui-router-transition-service/ui-router-transition-service';
import { StateService, Transition } from '@uirouter/core';

// Components
import { UptimesOverviewComponent } from './uptimes.component';
import { UptimeShowComponent } from './uptime-show/uptime-show.component';
import { CoreDomainService } from '@client/app/core/services/domain/core-domain.service';

@Component({
    selector: 'base-uptimes',
    template: `<ui-view name="content"></ui-view>`,
    standalone: true,
    imports: [UIRouterModule],
})
class BaseUptimesComponent {}

// Resolver functions
const validateAccess = [
    SessionService,
    MonUIRouterTransitionService,
    StateService,
    Transition,
    (
        ng2SessionService: SessionService,
        ng2MonUIRouterTransitionService: MonUIRouterTransitionService,
        $state: StateService,
        transition: Transition,
    ) => {
        if (ng2SessionService.customer !== null && ng2SessionService.customer.plan_traits.heartbeat) {
            return Promise.resolve(true);
        } else {
            ng2MonUIRouterTransitionService.onTransitionFinished(
                () => {
                    $state.go('base.customer.domain.dashboard', transition.params());
                },
            );
            return Promise.reject(new Error('Customer plan does not include heartbeat'));
        }
    },
];

const validateDomain = [
    SessionService,
    CoreDomainService,
    MonUIRouterTransitionService,
    StateService,
    Transition,
    (
        ng2SessionService: SessionService,
        coreDomainService: CoreDomainService,
        ng2MonUIRouterTransitionService: MonUIRouterTransitionService,
        $state: StateService,
        transition: Transition,
    ) => {
        if (ng2SessionService.domainGroup !== null) {
            coreDomainService.changeDomain();
            ng2MonUIRouterTransitionService.onTransitionFinished(
                () => {
                    $state.go('base.customer.domain.dashboard', transition.params());
                },
            );
            return Promise.reject(new Error('Domain validation failed'));
        } else {
            return Promise.resolve(true);
        }
    },
];

const redirectUptimes = [
    UptimeRepoService,
    MonUIRouterTransitionService,
    StateService,
    Transition,
    async (
        uptimeRepoService: UptimeRepoService,
        monUIRouterTransitionService: MonUIRouterTransitionService,
        stateService: StateService,
        transition: Transition,
    ) => {
        return new Promise((resolve, reject) => {
            uptimeRepoService.getAll({ page: 1, page_size: 10, status: 'active' })
                .then((uptimes: any) => {
                    if (uptimes.length === 1) {
                        transition.abort();
                        stateService.go('base.customer.domain.uptimes.show', {
                            uptimeId: uptimes[0].id,
                            domainId: transition.params().domainId,
                            customerId: transition.params().customerId,
                        });
                        monUIRouterTransitionService.onTransitionFinished(() => {
                        });
                    } else {
                        resolve(uptimes);
                    }
                }, () => {
                    transition.abort();
                    monUIRouterTransitionService.onTransitionFinished(
                        () => {
                            stateService.go('base.dashboard');
                        },
                    );
                });
        });

    },
];

const checkpointCount = [
    UptimeRepoService,
    Transition,
    (uptimeRepoService: UptimeRepoService, transition: Transition) => {
        return uptimeRepoService.getAll({ page: 1, page_size: 10, status: 'active' })
            .then((uptimes: any) => {
                return uptimes.length;
            });
    },
];

export const UPTIMES_STATES: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.domain.uptimes',
        url: '/uptimes',
        abstract: true,
        views: {
            'content@base.customer.domain': {
                component: BaseUptimesComponent,
            },
        },
        resolve: {
            validateAccess,
            validateDomain,
        },
    },
    {
        name: 'base.customer.domain.uptimes.index',
        url: '',
        views: {
            'content@base.customer.domain.uptimes': {
                component: UptimesOverviewComponent,
            },
        },
        resolve: {
            redirectUptimes,
        },
    },
    {
        name: 'base.customer.domain.uptimes.show',
        url: '/:uptimeId',
        views: {
            'content@base.customer.domain.uptimes': {
                component: UptimeShowComponent,
            },
        },
        resolve: {
            checkpoints: checkpointCount,
        },
    },
];
